document.addEventListener("DOMContentLoaded", function() {
    if(document.querySelector('.popupContact')){
        let popupContact = document.querySelectorAll('.popupContact');
        let popupModal = document.querySelector('.popup-contact');
        let popupClose = document.querySelector('.popup-contact__modal-close');
        
        popupContact.forEach(btn => {
            btn.addEventListener('click', function(){
                popupModal.classList.add('show');
            });
        })

        popupClose.addEventListener('click', function(){
            popupModal.classList.remove('show');
        })
        
        document.addEventListener('click', function(e){
            if(e.target == popupModal){
                popupModal.classList.remove('show');
            }
        })
    }

    if(document.querySelector('.popupRecrutement')){
        let popupRecrutement = document.querySelector('.popupRecrutement');
        let popupModalRecrutement = document.querySelector('.popup-recrutement');
        let popupCloseRecrutement = document.querySelector('.popup-recrutement__modal-close');
        

        popupRecrutement.addEventListener('click', function(){
            popupModalRecrutement.classList.add('show');
        });

        popupCloseRecrutement.addEventListener('click', function(){
            popupModalRecrutement.classList.remove('show');
        })
        
        document.addEventListener('click', function(e){
            if(e.target == popupModalRecrutement){
                popupModalRecrutement.classList.remove('show');
            }
        })
    }

    if(document.querySelector('.popupDevis')){
        let popupDevis = document.querySelectorAll('.popupDevis');
        let popupModalDevis = document.querySelector('.popup-devis');
        let popupCloseDevis = document.querySelector('.popup-devis__modal-close');
        
        popupDevis.forEach(btn => {
            btn.addEventListener('click', function(){
                popupModalDevis.classList.add('show');
            });
        })

        popupCloseDevis.addEventListener('click', function(){
            popupModalDevis.classList.remove('show');
        })
        
        document.addEventListener('click', function(e){
            if(e.target == popupModalDevis){
                popupModalDevis.classList.remove('show');
            }
        })
    }
});